import React from "react";
import PostAddForm from "../../../../components/forms/postItemsForm/index";
import { useState, useEffect } from "react";
import url from "../../../../config/axios";
import { useNavigate, useParams } from "react-router-dom";
import { SuccessNotify } from "../../../../constants/tostify";
import { FailedNotify } from "../../../../constants/tostify";
import { useSelector } from "react-redux";
import Loader from "../../../../components/Loader";
import { publishImage } from "../../../../helpers/imageupload";
import { useDropzone } from "react-dropzone";
const HomeMadePostAddForm = () => {
  const { name } = useSelector((state) => state.user);
  const [displayimg, setDisplayimg] = useState();
  const [shopCategory, setShopCategory] = useState()
  const [shopCategorytwo, setShopCategorytwo] = useState()
    const [isUploading, setIsUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const { index } = useParams();
  const [isloading, setIsloading] = useState(false);
  const navigate = useNavigate();
  const [data, setData] = useState({
    category: "",
    subCategory: ""
  })
  const [mygetitem, setMygetitem] = useState();

  useEffect(() => {
    setMygetitem(localStorage.getItem('mycategory'))
  }, [])

  const FirstCategory = () => {
    url.get(`/category/type/?type=homemadeShop&parentCategory=${mygetitem}`)
      .then(async (response) => {

        if (response?.data?.success) {
          setShopCategory(response?.data?.data?.Category);
        }
      })
      .catch((error) => {
        console.log("servicesCategories", error)
      });
  }
  const Handledata = (e) => {
    setData((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value.split(".")

    }))
  }

  const categoryName = data?.category[1];
  const categoryid = data.category[0];
  const subcategoryName = data?.subCategory[1];
  const subcategoryid = data.subCategory[0];

  const onDrop = async (acceptedFiles) => {
    try {
        setIsUploading(true);
      setUploadProgress(0);

      const abc = await publishImage(acceptedFiles, (percent) => {
        setUploadProgress(percent);
      });
      setUserData((userData) => ({
        ...userData,
        images: abc
      }));

      setDisplayimg(abc);

    } catch (error) {
      FailedNotify("Failed! Try Again");
    } finally {
      setIsUploading(false);
      setUploadProgress(0);
    }
  }

  const { getRootProps, getInputProps } = useDropzone({
    accept: "image/*",
    onDrop,
  });
  const [userData, setUserData] = useState({
    userid: name?._id,
    shopid: index,
    itemname: "",
    price: "",
    category: "",
    categoryid: "",
    subCategory: "",
    subCategoryid: "",
    totalquantity: "",
    country: "",
    city: "",
    state: "",
    images: [""],
    description: "",
    status: true,
  });

  useEffect(() => {
    setUserData((userData) => ({
      ...userData,
      category: categoryName,
      categoryid: categoryid,
      subCategory: subcategoryName,
      subCategoryid: subcategoryid

    }));

  }, [categoryid, categoryName, subcategoryName, subcategoryid]);



  useEffect(() => {
    url
      .get("/category/type/?type=homemadeShopItem&parentCategory=")
      .then(async (response) => {
        if (response?.data?.success) {
          setShopCategory(response?.data?.data?.Category);
        }
      })
      .catch((error) => {
        console.log("servicesCategories", error)
      });
  }, [])



  const Mydata = () => {

    url
      .get(`/category/type/?type=homemadeShopItem&parentCategory=${categoryName}`)
      .then(async (response) => {
        if (response?.data?.success) {
          setShopCategorytwo(response?.data?.data?.Category);
        }
      })
      .catch((error) => {
        console.log("servicesCategories", error)
      });
  }
  const Updatefunction = (e) => {
    setIsloading(true);
    e.preventDefault();
    url
      .put(`shopitem/id/?id=${index}`, userData)
      .then(async (response) => {
        if (response.data.success) {
          setIsloading(false);
          setTimeout(() => {
            SuccessNotify("Add Update Successfully");
          }, 1000);
          navigate(
            `/homemadeownerprofile/${response?.data?.data?.ShopItem?.shopid}`
          );
        }
      })
      .catch((e) => {
        setIsloading(false);
        FailedNotify("Failed To Update Try Again!");
      });
  };

  useEffect(() => {
    url.get(`shopitem/id/?id=${index}`).then(async (response) => {
      setUserData(response?.data?.data?.ShopItem);
    });
  }, []);

  if (isloading) {
    return <Loader heightsetting="screenHeight" />;
  }

  return (
    <PostAddForm
      butn="Update"
      Updatehandler={Updatefunction}
      setUserData={setUserData}
      userData={userData}
      updateurl="/homemade-item-update/"
      backurl="/homeMade-item-owner-view"
      index={index}
      Mydata={Mydata}
      Handledata={Handledata}
      shopCategory={shopCategory}
      shopCategorytwo={shopCategorytwo}
      FirstCategory={FirstCategory}
      getInputProps={getInputProps}
      getRootProps={getRootProps}
      displayimg={displayimg}
      setDisplayimg={setDisplayimg}
      isUploading={isUploading}           
uploadProgress={uploadProgress}
    />
  );
};

export default HomeMadePostAddForm;
